module.exports = __webpack_public_path__ + "img/flag_italy.48651b91.svg";